import { createContext, useContext, useEffect, useMemo, useState } from 'react';

export const DISPLAY_LANGUAGES = [
  { code: 'en', label: '🇬🇧 English' },
  { code: 'th', label: '🇹🇭 ไทย' },
  { code: 'zh', label: '🇨🇳 中文' },
  { code: 'ko', label: '🇰🇷 한국어' },
  { code: 'ja', label: '🇯🇵 日本語' },
];

const messages = {
  en: {
    feed: 'Feed', caddies: 'Caddies', messages: 'Messages', post: 'Post', profile: 'Profile',
    signOut: 'Sign out', signIn: 'Sign in', signUp: 'Sign up', displayLanguage: 'Display language',
    findCaddie: 'Find a caddie', findCaddieHint: 'Search by name, golf course, or profile details.',
    searchCaddies: 'Search caddies...', allGolfCourses: 'All golf courses', allLanguages: 'All languages',
    noCaddies: 'No caddies found.', tryDifferent: 'Try a different name or golf course.',
    golfCourseNotSet: 'Golf course not set', follow: 'Follow', following: 'Following',
    noConversations: 'No conversations yet.', findAndDm: 'Find a caddie and send them a DM!',
    startConversation: 'Start the conversation', typeMessage: 'Type a message...', send: 'Send',
    editProfile: 'Edit profile', cancel: 'Cancel', message: 'Message', privatePhone: 'Private phone number',
    languagesSpoken: 'Languages spoken', bio: 'Bio', saveChanges: 'Save changes', saving: 'Saving...',
    availability: 'Availability', posts: 'Posts', noPosts: 'No posts yet.',
    completeProfile: 'Complete your caddie profile',
    privateContactNote: 'Help golfers find you. Your contact information stays private.',
    golfCourse: 'Golf course / workplace', phoneNumber: 'Private phone number', shortBio: 'Short bio',
    skip: 'Skip for now', saveProfile: 'Save profile',
    welcomeBack: 'Welcome back', signInHint: 'Sign in to your account', email: 'Email', password: 'Password',
    signingIn: 'Signing in...', noAccount: "Don't have an account?", createAccount: 'Create your account',
    joinToday: 'Join Mahanakhon Golf today', displayName: 'Display name', yourName: 'Your name',
    minPassword: 'Min 8 characters', iAmA: 'I am a...', golfer: 'Golfer', caddie: 'Caddie',
    golferDesc: 'Browse & connect with caddies', caddieDesc: 'Post photos & get bookings',
    creatingAccount: 'Creating account...', alreadyAccount: 'Already have an account?',
    newPost: 'New Post', noFeedPosts: 'No posts yet.', firstPost: 'Be the first to post!',
    hero: 'Connect with the best caddies in Bangkok. Browse caddie profiles, check availability, and book your perfect round.',
    goToFeed: 'Go to Feed', getStarted: 'Get Started', why: 'Why Mahanakhon Golf?', meetCaddies: 'Meet Our Caddies',
    seeAllCaddies: 'See all caddies',
    statusLine: 'Status line', changePhoto: 'Change photo',
    emptyGolferProfile: 'This golfer has not added profile details yet.',
  },
  th: {
    feed: 'ฟีด', caddies: 'แคดดี้', messages: 'ข้อความ', post: 'โพสต์', profile: 'โปรไฟล์',
    signOut: 'ออกจากระบบ', signIn: 'เข้าสู่ระบบ', signUp: 'สมัครสมาชิก', displayLanguage: 'ภาษาที่แสดง',
    findCaddie: 'ค้นหาแคดดี้', findCaddieHint: 'ค้นหาด้วยชื่อ สนามกอล์ฟ หรือรายละเอียดโปรไฟล์',
    searchCaddies: 'ค้นหาแคดดี้...', allGolfCourses: 'ทุกสนามกอล์ฟ', allLanguages: 'ทุกภาษา',
    noCaddies: 'ไม่พบแคดดี้', tryDifferent: 'ลองค้นหาด้วยชื่อหรือสนามกอล์ฟอื่น',
    golfCourseNotSet: 'ยังไม่ได้ระบุสนามกอล์ฟ', follow: 'ติดตาม', following: 'กำลังติดตาม',
    noConversations: 'ยังไม่มีบทสนทนา', findAndDm: 'ค้นหาแคดดี้แล้วส่งข้อความได้เลย',
    startConversation: 'เริ่มบทสนทนา', typeMessage: 'พิมพ์ข้อความ...', send: 'ส่ง',
    editProfile: 'แก้ไขโปรไฟล์', cancel: 'ยกเลิก', message: 'ข้อความ', privatePhone: 'เบอร์โทรส่วนตัว',
    languagesSpoken: 'ภาษาที่พูดได้', bio: 'ประวัติย่อ', saveChanges: 'บันทึกการเปลี่ยนแปลง', saving: 'กำลังบันทึก...',
    availability: 'วันว่าง', posts: 'โพสต์', noPosts: 'ยังไม่มีโพสต์',
    completeProfile: 'กรอกโปรไฟล์แคดดี้ให้สมบูรณ์',
    privateContactNote: 'ช่วยให้นักกอล์ฟค้นหาคุณได้ ข้อมูลติดต่อของคุณจะเป็นส่วนตัว',
    golfCourse: 'สนามกอล์ฟ / สถานที่ทำงาน', phoneNumber: 'เบอร์โทรส่วนตัว', shortBio: 'ประวัติย่อ',
    skip: 'ข้ามไปก่อน', saveProfile: 'บันทึกโปรไฟล์',
    welcomeBack: 'ยินดีต้อนรับกลับ', signInHint: 'เข้าสู่ระบบบัญชีของคุณ', email: 'อีเมล', password: 'รหัสผ่าน',
    signingIn: 'กำลังเข้าสู่ระบบ...', noAccount: 'ยังไม่มีบัญชี?', createAccount: 'สร้างบัญชี',
    joinToday: 'เข้าร่วม Mahanakhon Golf วันนี้', displayName: 'ชื่อที่แสดง', yourName: 'ชื่อของคุณ',
    minPassword: 'อย่างน้อย 8 ตัวอักษร', iAmA: 'ฉันเป็น...', golfer: 'นักกอล์ฟ', caddie: 'แคดดี้',
    golferDesc: 'ค้นหาและติดต่อแคดดี้', caddieDesc: 'โพสต์รูปและรับการจอง',
    creatingAccount: 'กำลังสร้างบัญชี...', alreadyAccount: 'มีบัญชีแล้ว?',
    newPost: 'โพสต์ใหม่', noFeedPosts: 'ยังไม่มีโพสต์', firstPost: 'โพสต์เป็นคนแรก!',
    hero: 'เชื่อมต่อกับแคดดี้ชั้นนำในกรุงเทพฯ ดูโปรไฟล์ เช็กวันว่าง และเตรียมออกรอบของคุณ',
    goToFeed: 'ไปที่ฟีด', getStarted: 'เริ่มต้นใช้งาน', why: 'ทำไมต้อง Mahanakhon Golf?', meetCaddies: 'พบกับแคดดี้ของเรา',
    seeAllCaddies: 'ดูแคดดี้ทั้งหมด',
    statusLine: 'ข้อความสถานะ', changePhoto: 'เปลี่ยนรูป',
    emptyGolferProfile: 'นักกอล์ฟคนนี้ยังไม่ได้เพิ่มรายละเอียดโปรไฟล์',
  },
  zh: {
    feed: '动态', caddies: '球童', messages: '消息', post: '发布', profile: '个人资料',
    signOut: '退出', signIn: '登录', signUp: '注册', displayLanguage: '显示语言',
    findCaddie: '寻找球童', findCaddieHint: '按姓名、高尔夫球场或个人资料搜索。',
    searchCaddies: '搜索球童...', allGolfCourses: '所有高尔夫球场', allLanguages: '所有语言',
    noCaddies: '未找到球童。', tryDifferent: '请尝试其他姓名或高尔夫球场。',
    golfCourseNotSet: '未设置高尔夫球场', follow: '关注', following: '已关注',
    noConversations: '暂无对话。', findAndDm: '寻找球童并发送私信！',
    startConversation: '开始对话', typeMessage: '输入消息...', send: '发送',
    editProfile: '编辑资料', cancel: '取消', message: '消息', privatePhone: '私人电话号码',
    languagesSpoken: '会说的语言', bio: '简介', saveChanges: '保存更改', saving: '保存中...',
    availability: '可用时间', posts: '帖子', noPosts: '暂无帖子。',
    completeProfile: '完善球童资料', privateContactNote: '帮助球手找到您。您的联系方式将保持私密。',
    golfCourse: '高尔夫球场 / 工作地点', phoneNumber: '私人电话号码', shortBio: '简短介绍',
    skip: '暂时跳过', saveProfile: '保存资料',
    welcomeBack: '欢迎回来', signInHint: '登录您的账户', email: '电子邮件', password: '密码',
    signingIn: '登录中...', noAccount: '还没有账户？', createAccount: '创建账户',
    joinToday: '立即加入 Mahanakhon Golf', displayName: '显示名称', yourName: '您的姓名',
    minPassword: '至少 8 个字符', iAmA: '我是...', golfer: '球手', caddie: '球童',
    golferDesc: '浏览并联系球童', caddieDesc: '发布照片并接受预订',
    creatingAccount: '正在创建账户...', alreadyAccount: '已有账户？',
    newPost: '新帖子', noFeedPosts: '暂无帖子。', firstPost: '发布第一个帖子！',
    hero: '联系曼谷优秀的球童。浏览资料、查看空闲时间，准备您的完美球局。',
    goToFeed: '前往动态', getStarted: '开始使用', why: '为什么选择 Mahanakhon Golf？', meetCaddies: '认识我们的球童',
    seeAllCaddies: '查看所有球童',
    statusLine: '状态', changePhoto: '更换照片',
    emptyGolferProfile: '该球手尚未添加个人资料。',
  },
  ko: {
    feed: '피드', caddies: '캐디', messages: '메시지', post: '게시', profile: '프로필',
    signOut: '로그아웃', signIn: '로그인', signUp: '가입', displayLanguage: '표시 언어',
    findCaddie: '캐디 찾기', findCaddieHint: '이름, 골프장 또는 프로필 정보로 검색하세요.',
    searchCaddies: '캐디 검색...', allGolfCourses: '모든 골프장', allLanguages: '모든 언어',
    noCaddies: '캐디를 찾지 못했습니다.', tryDifferent: '다른 이름이나 골프장을 시도하세요.',
    golfCourseNotSet: '골프장 미설정', follow: '팔로우', following: '팔로잉',
    noConversations: '아직 대화가 없습니다.', findAndDm: '캐디를 찾아 DM을 보내세요!',
    startConversation: '대화 시작', typeMessage: '메시지 입력...', send: '보내기',
    editProfile: '프로필 수정', cancel: '취소', message: '메시지', privatePhone: '비공개 전화번호',
    languagesSpoken: '사용 가능 언어', bio: '소개', saveChanges: '변경 사항 저장', saving: '저장 중...',
    availability: '가능 일정', posts: '게시물', noPosts: '게시물이 없습니다.',
    completeProfile: '캐디 프로필 완성', privateContactNote: '골퍼가 회원님을 찾을 수 있도록 도와주세요. 연락처는 비공개입니다.',
    golfCourse: '골프장 / 근무지', phoneNumber: '비공개 전화번호', shortBio: '간단한 소개',
    skip: '나중에', saveProfile: '프로필 저장',
    welcomeBack: '다시 오신 것을 환영합니다', signInHint: '계정에 로그인하세요', email: '이메일', password: '비밀번호',
    signingIn: '로그인 중...', noAccount: '계정이 없으신가요?', createAccount: '계정 만들기',
    joinToday: '지금 Mahanakhon Golf에 가입하세요', displayName: '표시 이름', yourName: '이름',
    minPassword: '최소 8자', iAmA: '저는...', golfer: '골퍼', caddie: '캐디',
    golferDesc: '캐디 검색 및 연결', caddieDesc: '사진 게시 및 예약 받기',
    creatingAccount: '계정 생성 중...', alreadyAccount: '이미 계정이 있으신가요?',
    newPost: '새 게시물', noFeedPosts: '게시물이 없습니다.', firstPost: '첫 게시물을 작성하세요!',
    hero: '방콕 최고의 캐디와 연결하세요. 프로필과 가능 일정을 확인하고 완벽한 라운드를 준비하세요.',
    goToFeed: '피드로 이동', getStarted: '시작하기', why: '왜 Mahanakhon Golf인가요?', meetCaddies: '캐디 만나기',
    seeAllCaddies: '모든 캐디 보기',
    statusLine: '상태 메시지', changePhoto: '사진 변경',
    emptyGolferProfile: '이 골퍼는 아직 프로필 정보를 추가하지 않았습니다.',
  },
  ja: {
    feed: 'フィード', caddies: 'キャディー', messages: 'メッセージ', post: '投稿', profile: 'プロフィール',
    signOut: 'ログアウト', signIn: 'ログイン', signUp: '登録', displayLanguage: '表示言語',
    findCaddie: 'キャディーを探す', findCaddieHint: '名前、ゴルフ場、プロフィール情報で検索できます。',
    searchCaddies: 'キャディーを検索...', allGolfCourses: 'すべてのゴルフ場', allLanguages: 'すべての言語',
    noCaddies: 'キャディーが見つかりません。', tryDifferent: '別の名前やゴルフ場をお試しください。',
    golfCourseNotSet: 'ゴルフ場未設定', follow: 'フォロー', following: 'フォロー中',
    noConversations: '会話はまだありません。', findAndDm: 'キャディーを探してDMを送りましょう。',
    startConversation: '会話を始める', typeMessage: 'メッセージを入力...', send: '送信',
    editProfile: 'プロフィールを編集', cancel: 'キャンセル', message: 'メッセージ', privatePhone: '非公開の電話番号',
    languagesSpoken: '話せる言語', bio: '自己紹介', saveChanges: '変更を保存', saving: '保存中...',
    availability: '空き状況', posts: '投稿', noPosts: '投稿はまだありません。',
    completeProfile: 'キャディープロフィールを完成する', privateContactNote: 'ゴルファーがあなたを見つけやすくします。連絡先は非公開です。',
    golfCourse: 'ゴルフ場 / 勤務先', phoneNumber: '非公開の電話番号', shortBio: '短い自己紹介',
    skip: '後で', saveProfile: 'プロフィールを保存',
    welcomeBack: 'おかえりなさい', signInHint: 'アカウントにログイン', email: 'メール', password: 'パスワード',
    signingIn: 'ログイン中...', noAccount: 'アカウントをお持ちでないですか？', createAccount: 'アカウント作成',
    joinToday: 'Mahanakhon Golfに参加しましょう', displayName: '表示名', yourName: 'お名前',
    minPassword: '8文字以上', iAmA: '私は...', golfer: 'ゴルファー', caddie: 'キャディー',
    golferDesc: 'キャディーを探して連絡', caddieDesc: '写真を投稿して予約を受ける',
    creatingAccount: 'アカウント作成中...', alreadyAccount: 'アカウントをお持ちですか？',
    newPost: '新規投稿', noFeedPosts: '投稿はまだありません。', firstPost: '最初の投稿をしましょう！',
    hero: 'バンコクの優れたキャディーとつながりましょう。プロフィールと空き状況を確認して、最高のラウンドを準備できます。',
    goToFeed: 'フィードへ', getStarted: '始める', why: 'Mahanakhon Golfを選ぶ理由', meetCaddies: 'キャディー紹介',
    seeAllCaddies: 'すべてのキャディーを見る',
    statusLine: 'ステータス', changePhoto: '写真を変更',
    emptyGolferProfile: 'このゴルファーはまだプロフィールを追加していません。',
  },
};

const LocaleContext = createContext(null);

export function LocaleProvider({ children }) {
  const [locale, setLocale] = useState(() => localStorage.getItem('mg_locale') || 'en');

  useEffect(() => {
    localStorage.setItem('mg_locale', locale);
    document.documentElement.lang = locale;
  }, [locale]);

  const value = useMemo(() => ({
    locale,
    setLocale,
    t: (key) => messages[locale]?.[key] ?? messages.en[key] ?? key,
  }), [locale]);

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export function useLocale() {
  const context = useContext(LocaleContext);
  if (!context) throw new Error('useLocale must be used inside <LocaleProvider>');
  return context;
}
